import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(() => ({
  // styles for element, that will be hidden and can be read by screen reader
  screenReaderVisuallyHidden: {
    border: 0,
    padding: 0,
    margin: 0,
    position: "absolute",
    height: "1px",
    width: "1px",
    overflow: "hidden",
    clipPath: "inset(50%)", // clips to a 0px square
    whiteSpace: "nowrap" // added line to stop words getting smushed together (as they go onto seperate lines and some screen readers do not understand line feeds as a space
  }
}))
